export const PaymentProvider = Object.freeze({
  APPLE: 0,
  STRIPE: 1,
  PAYPAL: 2,
});

/**
 * It handles operations final status in the view for user
 * @enum {number}
 */
export const PaymentOperationStatus = Object.freeze({
  PENDING: 0,
  SUCCESS: 1,
  FAILED: 2,
});

export const SavedPaymentTokenType = Object.freeze({
  CARD: 1,
  EMAIL: 2,
});
